export const isFunc = fn => typeof fn === 'function';
